import { fetchWithAuth } from './core'

export type UploadedImageDocument = {
  documentId: string
  filePath?: string
  title?: string
}

/** Create a first-class image document from a local file dropped into a folder. */
export async function uploadImageDocumentFile(opts: {
  file: File
  folderPath: string
}): Promise<UploadedImageDocument> {
  const form = new FormData()
  form.append('file', opts.file, opts.file.name)
  form.append('folderPath', opts.folderPath)
  form.append('filename', opts.file.name)

  const response = await fetchWithAuth('/api/images/upload', {
    method: 'POST',
    body: form,
  })
  const body = await response.json().catch(() => ({} as { error?: string; details?: string; documentId?: string; filePath?: string; title?: string; success?: boolean }))
  if (!response.ok || body.success === false || !body.documentId) {
    throw new Error(body.details || body.error || `Upload failed (${response.status})`)
  }
  return {
    documentId: body.documentId,
    filePath: body.filePath,
    title: body.title,
  }
}

/** Download original image bytes through the authenticated image route. */
export async function downloadImageDocumentFile(
  documentId: string,
  filename: string,
): Promise<void> {
  const response = await fetchWithAuth(`/api/images/${documentId}/image`)
  if (!response.ok) {
    throw new Error(`Download failed (${response.status})`)
  }
  const blob = await response.blob()
  const url = URL.createObjectURL(blob)
  try {
    const link = window.document.createElement('a')
    link.href = url
    link.download = filename || 'image'
    window.document.body.appendChild(link)
    link.click()
    link.remove()
  } finally {
    URL.revokeObjectURL(url)
  }
}
